import React, { useRef, useEffect } from 'react';

interface Props {
  children: React.ReactNode;
  onEnter?: () => void;
  onLeave?: () => void;
}

export function ViewportObserver({ children, onEnter, onLeave }: Props): JSX.Element {
  const divRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onEnter?.();
        } else {
          onLeave?.();
        }
      });
    });

    if (divRef.current) observer.observe(divRef.current);
    return () => {
      divRef.current && observer.unobserve(divRef.current);
    };
  }, [onEnter, onLeave]);
  return <div ref={divRef}>{children}</div>;
}
